// This file is auto-generated from Ruby constants.
// Do not edit manually. Use rake export_ts_constants to regenerate.

export const PARTNER_CONSTRAINT = {
  partner: "(?-mix:[a-zA-Z0-9_]+)",
  router: "(?-mix:router)",
};

export const COMPANY_ID_TOKEN_CONSTRAINT = {
  company_id_token: "(?-mix:[a-zA-Z0-9_]+)",
};

export const LAUNCHED_STATES = [
  "AK",
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MO",
  "MS",
  "MT",
  "NC",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "TN",
  "TX",
  "UT",
  "VA",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const STATES_BY_SIZE_2023 = [
  "CA",
  "TX",
  "FL",
  "NY",
  "GA",
  "IL",
  "VA",
  "WA",
  "NC",
  "NJ",
  "PA",
  "CO",
  "OH",
  "AZ",
  "TN",
  "MI",
  "MD",
  "MO",
  "MA",
  "IN",
  "OR",
  "NV",
  "AL",
  "MN",
  "SC",
  "WI",
  "LA",
  "OK",
  "UT",
  "CT",
  "KS",
  "KY",
  "AR",
  "ID",
  "MS",
  "IA",
  "NH",
  "NM",
  "NE",
  "MT",
  "ME",
  "DE",
  "WV",
  "AK",
  "WY",
  "SD",
  "ND",
  "RI",
  "HI",
  "DC",
  "VT",
  "PR",
  "VI",
  "GU",
  "AS",
  "MP",
];

export const STATES_BY_SIZE = [
  "CA",
  "TX",
  "FL",
  "NY",
  "PA",
  "GA",
  "NJ",
  "IL",
  "WA",
  "VA",
  "OH",
  "AZ",
  "NC",
  "MA",
  "MD",
  "IN",
  "MO",
  "CO",
  "IA",
  "MI",
  "KY",
  "TN",
  "AL",
  "CT",
  "MN",
  "OR",
  "SC",
  "WI",
  "NV",
  "DE",
  "DC",
  "AR",
  "OK",
  "LA",
  "MT",
  "NH",
  "UT",
  "KS",
  "MS",
  "ME",
  "NE",
  "RI",
  "WY",
  "AK",
  "HI",
  "ID",
  "ND",
  "NM",
  "SD",
  "WV",
];

export const DISABLED_STATES = ["DC", "VT"];

export const DENTAL_LAUNCHED_STATES = ["CA", "TX", "MA"];

export const VISION_LAUNCHED_STATES = ["CA", "TX"];

export const EARLY_DEADLINE_STATES = ["NY", "WA", "PA", "OH", "MA", "MD"];

export const BLUE_SHIELD_CA_REGION_MAP = {
  central: [2, 8, 10, 11, 13, 14],
  northern: [1, 3, 4, 5, 6, 7, 9],
  southern: [12, 15, 16, 17, 18, 19],
};

export const BCBS_TX_REGION_MAP = {
  region_1: [3, 8, 10, 20, 25, 26],
  region_2: [1, 2, 4, 5, 6, 7, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 23, 24],
};

export const PARTIAL_STATES = ["MT"];

export const LAUNCHED_REGIONS_BY_STATE = {
  MT: [1, 2, 3],
};

export const SALES_PHONE_NUMBER = "(888) 584-9220";

export const INDIVIDUAL_SALES_PHONE_NUMBER = "(866) 923-0512";

export const SUPPORT_PHONE_NUMBER = "(888) 584-7457";

export const SEM_PHONE_NUMBERS = {
  "0": "(855) 305-5740",
  "1": "(888) 584-9220",
};

export const AUTO_SUBMISSION_EMAIL = {
  anthem: "SmallGroupE&BSupport@Anthem.com",
  united_healthcare: "clientserviceoperations@uhc.com",
  blue_shield_ca: "small.group@blueshieldca.com",
};

export const AUTO_TERMINATION_EMAIL = {
  anthem: "SmallGroupE&BSupport@Anthem.com",
  united_healthcare: "clientserviceoperations@uhc.com",
  bcbsma: "insideservice@bcbsma.com",
};

export const ANTHEM_SUBMISSION_AND_TERMINATION_EMAIL = "SmallGroupE&BSupport@Anthem.com";

export const EMAIL_REGEX = "(?i-mx:^[-a-z0-9_+.]+@([-a-z0-9]+.)+[a-z0-9]{2,4}$)";

export const AGENCY_INSURANCE_LICENSES = {
  National: "17197729",
  Alabama: "726278",
  Alaska: "100118545",
  Arizona: "1110398",
  Arkansas: "100129132",
  California: "0I77135",
  Colorado: "477672",
  Connecticut: "2491244",
  Delaware: "2491244",
  Georgia: "184336",
  Hawaii: "425577",
  Idaho: "527576",
  Illinois: "100724651",
  Indiana: "1033991",
  Iowa: "1002250737",
  Maryland: "2167944",
  Minnesota: "40428548",
  Missouri: "3001800673",
  Nebraska: "100232868",
  Nevada: "1038564",
  "New Hampshire": "2316992",
  "New Jersey": "17197729",
  "North Carolina": "1000433052",
  "North Dakota": "2000143304",
  Oklahoma: "100223188",
  Oregon: "100262281",
  "South Dakota": "10018133",
  Tennessee: "2302430",
  Utah: "2302430",
  Vermont: "1034146",
  "West Virginia": "100197225",
  Wyoming: "286061",
};

export const INSURANCE_LICENSES = {
  National: "16841690",
  Alabama: "0691337",
  Alaska: "0100104296",
  Arizona: "1073454",
  Arkansas: "438357",
  California: "0I14828",
  Colorado: "447301",
  Connecticut: "2455800",
  Delaware: "1350673",
  "District of Columbia": "3060332",
  Florida: "W182201",
  Georgia: "2954171",
  Hawaii: "411537",
  Idaho: "481593",
  Illinois: "16841690",
  Indiana: "944572",
  Iowa: "016841690",
  Kansas: "16841690",
  Kentucky: "837433",
  Louisiana: "616204",
  Maine: "PRN230915",
  Maryland: "002136570",
  Massachusetts: "1947544",
  Michigan: "0672794",
  Minnesota: "40378055",
  Mississippi: "10327156",
  Missouri: "8315807",
  Montana: "0100115444",
  Nebraska: "0016841690",
  Nevada: "943897",
  "New Hampshire": "2289740",
  "New Jersey": "1543126",
  "New Mexico": "351744",
  "New York": "1317315",
  "North Carolina": "0016841690",
  "North Dakota": "0016841690",
  Ohio: "1018946",
  Oklahoma: "0100186492",
  Oregon: "16841690",
  Pennsylvania: "691968",
  "Rhode Island": "2281283",
  "South Carolina ": "720986",
  "South Dakota": "40356954",
  Tennessee: "2269674",
  Texas: "1873995",
  Utah: "481651",
  Vermont: "944267",
  Virginia: "906118",
  Washington: "856183",
  "West Virginia": "0016841690",
  Wisconsin: "2634062",
  Wyoming: "261648",
};

export const STATE_ABBREVIATIONS = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

export const STATES_PARAMETERIZED = [
  "alabama",
  "alaska",
  "american-samoa",
  "arizona",
  "arkansas",
  "california",
  "colorado",
  "connecticut",
  "delaware",
  "district-of-columbia",
  "florida",
  "georgia",
  "guam",
  "hawaii",
  "idaho",
  "illinois",
  "indiana",
  "iowa",
  "kansas",
  "kentucky",
  "louisiana",
  "maine",
  "maryland",
  "massachusetts",
  "michigan",
  "minnesota",
  "mississippi",
  "missouri",
  "montana",
  "nebraska",
  "nevada",
  "new-hampshire",
  "new-jersey",
  "new-mexico",
  "new-york",
  "north-carolina",
  "north-dakota",
  "ohio",
  "oklahoma",
  "oregon",
  "pennsylvania",
  "puerto-rico",
  "rhode-island",
  "south-carolina",
  "south-dakota",
  "tennessee",
  "texas",
  "utah",
  "vermont",
  "virgin-islands",
  "virginia",
  "washington",
  "west-virginia",
  "wisconsin",
  "wyoming",
];

export const STATES_INVERTED = {
  Alabama: "AL",
  Alaska: "AK",
  "American Samoa": "AS",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  "District of Columbia": "DC",
  Florida: "FL",
  Georgia: "GA",
  Guam: "GU",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Puerto Rico": "PR",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  "Virgin Islands": "VI",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

export const NORMALIZED_CARRIERS = {
  "a-division-of-health-care-service-corporation-a-mutual-legal-reserve-company-an-independent-licensee-of-the-blue-cross-and-blue-shield-association":
    "+A Division of Health Care Service Corporation a Mutual Legal Reserve Company, an Independent Licensee of the Blue Cross and Blue Shield Association",
  "aarp-branded-plans-insured-by-aetna": "AARP-branded plans, insured by Aetna",
  aetna: "Aetna",
  "aetna-life-insurance-company": "Aetna Life Insurance Company",
  "amerihealth-new-jersey": "AmeriHealth - New Jersey",
  "anthem-blue-cross": "Anthem Blue Cross",
  "assurant-health": "Assurant Health",
  "blue-cross-and-blue-shield-of-illinois": "Blue Cross and Blue Shield of Illinois",
  "blue-shield": "Blue Shield",
  "blue-shield-of-california": "Blue Shield of California",
  "carefirst-bluechoice-inc-is-an-independent-licensee-of-the-blue-cross-and-blue-shield-association-registered-trademark-of-the-blue-cross-and-blue-shield-association-registered-trademark-of-carefirst-of-maryland-inc":
    "CareFirst BlueChoice, Inc. is an independent licensee of the Blue Cross and Blue Shield Association. Registered trademark of the Blue Cross and Blue Shield Association. Registered trademark of CareFirst of Maryland, Inc.",
  "carefirst-bluecross-blueshield-is-the-shared-business-name-of-carefirst-of-maryland-inc-and-group-hospitalization-and-medical-services-inc-which-are-independent-licensees-of-the-blue-cross-and-blue-shield-association-registered-trademark-of-the-blue":
    "CareFirst BlueCross BlueShield is the shared business name of CareFirst of Maryland, Inc. and Group Hospitalization and Medical Services, Inc. which are independent licensees of the Blue Cross and Blue Shield Association. Registered trademark of the Blue",
  "celticare-healthplan-of-ma-inc": "CeltiCare Healthplan of MA, Inc.",
  cigna: "Cigna",
  "cigna-healthcare-of-florida-inc": "CIGNA HealthCare of Florida Inc",
  "coventry-health-and-life-insurance-co-fl": "Coventry Health and Life Insurance Co. Fl",
  "coventry-health-care-of-illinois-inc": "Coventry Health Care of Illinois, Inc.",
  "coventry-health-plan-of-florida-inc": "Coventry Health Plan of Florida, Inc.",
  "covered-california": "Covered California",
  "easy-choice-health-plan-of-new-york": "Easy Choice Health Plan of New York",
  emblemhealth: "EmblemHealth",
  "empire-healthchoice-assurance-inc": "Empire HealthChoice Assurance Inc",
  "empire-healthchoice-hmo-inc": "Empire HealthChoice HMO Inc",
  "fallon-community-health-plan": "Fallon Community Health Plan",
  "group-health-cooperative": "Group Health Cooperative",
  "group-health-options-inc": "Group Health Options, Inc.",
  "harvard-pilgrim": "Harvard Pilgrim",
  "health-net": "Health Net",
  healthnet: "HealthNet",
  "horizon-blue-cross-blue-shield-of-new-jersey": "Horizon Blue Cross Blue Shield of New Jersey",
  humana: "Humana",
  "humana-insurance-company": "Humana Insurance Company",
  "ihc-group": "IHC Group",
  "kaiser-mid-atlantic": "Kaiser Mid-Atlantic",
  "kaiser-permanente": "Kaiser Permanente",
  "kaiser-permanente-of-ca": "Kaiser Permanente of CA",
  "lifewise-health-plan-of-washington": "LifeWise Health Plan of Washington",
  "mvp-health-care": "MVP Health Care",
  "oxford-nj": "Oxford NJ",
  "oxford-ny": "Oxford NY",
  "regence-blueshield-is-an-independent-licensee-of-the-blue-cross-and-blue-shield-association":
    "Regence BlueShield is an independent licensee of the Blue Cross and Blue Shield Association.",
  "scott-white-health-plan": "Scott & White Health Plan",
  "see-change": "See Change",
  "tufts-health-plan": "Tufts Health Plan",
  "united-healthcare": "United Healthcare",
  unitedhealthone: "UnitedHealthOne",
  unitedhealthcare: "UnitedHealthcare",
  "chinese-community-health-plan": "Chinese Community Health Plan",
  "contra-costa-health-services": "Contra Costa Health Services",
  "l-a-care-health-plan": "L.A. Care Health Plan",
  "molina-healthcare": "Molina Healthcare",
  seechange: "SeeChange",
  sharp: "Sharp",
  "western-health-advantage": "Western Health Advantage",
  connecticare: "Connecticare",
  "harvard-pilgrim-health-care": "Harvard Pilgrim Health Care",
  "healthy-ct": "Healthy CT",
  "oxford-health-plan": "Oxford Health Plan",
  "carefirst-bcbs": "CareFirst BCBS",
  avmed: "AvMed",
  "florida-blue": "Florida Blue",
  bcbs: "BCBS",
  "coventry-health-care": "Coventry Health Care",
  "bcbs-idaho": "BCBS Idaho",
  "blue-cross-blue-shield-il": "Blue Cross Blue Shield IL",
  "blue-cross-blue-shield-ma": "Blue Cross Blue Shield MA",
  "carefirst-bcbs-shop": "CareFirst BCBS SHOP",
  "carefirst-bluecross-blueshield": "CareFirst BlueCross BlueShield",
  coventry: "Coventry",
  "kaiser-permanente-shop": "Kaiser Permanente SHOP",
  "blue-cross-blue-shield-mi": "Blue Cross Blue Shield MI",
  "blue-cross-blue-shield-of-mi": "Blue Cross Blue Shield of MI",
  "priority-health": "Priority Health",
  "bcbs-mt": "BCBS MT",
  "minuteman-health": "Minuteman Health",
  amerihealth: "AmeriHealth",
  "cigna-healthcare": "Cigna Healthcare",
  "health-republic": "Health Republic",
  "horizon-bcbs": "Horizon BCBS",
  oxford: "Oxford",
  "aetna-dependent-30-plans": "Aetna - Dependent 30 Plans",
  careconnect: "CareConnect",
  "crystal-run": "Crystal Run",
  "easy-choice-ny": "Easy Choice NY",
  "empire-bcbs": "Empire BCBS",
  "empire-blue-cross-blue-shield": "Empire Blue Cross Blue Shield",
  "empire-blue-priority": "Empire Blue Priority",
  "empire-epo-ppo-bluecard": "Empire EPO/PPO (BlueCard)",
  "empire-pathway": "Empire Pathway",
  "excellus-bcbs": "Excellus BCBS",
  "healthpass-careconnect": "HealthPass/CareConnect",
  "healthpass-easychoice-ny": "HealthPass/EasyChoice NY",
  "healthpass-health-republic": "HealthPass/Health Republic",
  "healthpass-oxford": "HealthPass/Oxford",
  "lia-careconnect": "LIA/CareConnect",
  "lia-health-republic": "LIA/Health Republic",
  "lia-mvp": "LIA/MVP",
  "lia-north-shore-lij": "LIA/North Shore LIJ",
  "mvp-hqnet-defined-ntwk": "MVP HQNet (Defined Ntwk)",
  "north-shore-lij-careconnect": "North Shore-LIJ CareConnect",
  "nyha-careconnect": "NYHA/CareConnect",
  "nyha-mvp": "NYHA/MVP",
  "nysbg-health-republic": "NYSBG/Health Republic",
  oscar: "Oscar",
  "oxford-freedom": "Oxford Freedom",
  "oxford-liberty": "Oxford Liberty",
  "oxford-metro": "Oxford Metro",
  "anthem-blue-cross-oh": "Anthem Blue Cross OH",
  "medical-mutual": "Medical Mutual",
  "medical-mutual-of-oh": "Medical Mutual of OH",
  "blue-cross-blue-shield-ok": "Blue Cross Blue Shield OK",
  pacificsource: "PacificSource",
  "regence-blue-shield": "Regence Blue Shield",
  highmark: "Highmark",
  "independence-blue-cross": "Independence Blue Cross",
  "independence-blue-cross-pa": "Independence Blue Cross PA",
  "blue-cross-blue-shield": "Blue Cross Blue Shield",
  "blue-cross-blue-shield-of-tx": "Blue Cross Blue Shield of TX",
  "memorial-hermann-health-solutions": "Memorial Hermann Health Solutions",
  "regence-bluecross-blueshield": "Regence BlueCross BlueShield",
  "premera-blue-cross": "Premera Blue Cross",
};

export const WAGE_REPORT_SHORT_NAMES = {
  AL: "UTR (Unemployment Tax Report)",
  AK: "TQ01C",
  AZ: "UC-018",
  AR: "DWS-ARK-209B",
  CA: "DE9C",
  CO: "UITR-1/UITR-1a",
  CT: "UC-5A",
  DC: "UC-30",
  DE: "QTR (Quarterly Tax Report)",
  FL: "RT-6",
  GA: "DOL-4N",
  HI: "Form UC-B6",
  ID: "TAX026",
  IL: "UI 3/40",
  IN: "UC-5A",
  IA: "Form 65-5300",
  KS: "K-CNS 100",
  KY: "QWCR (Quarterly Wage Contribution Report)",
  LA: "LWC ES-4",
  ME: "Form C1-ME",
  MD: "DLLR/DUI-15/16",
  MA: "WR-2",
  MI: "UIA 1028 Employer's Quarterly Wage/Tax Report",
  MN: "Quarterly Unemployement Tax & Wage Detail Report",
  MS: "MODES-4",
  MO: "QWR (Quarterly Wage Report)",
  MT: "Form UI-5G",
  NE: "UI-11W",
  NV: "NUCS 4072",
  NH: "NH Employment Security - Employer Quarterly Tax and Wage Report",
  NJ: "WR-30",
  NM: "ES903A",
  NY: "NYS-45",
  NC: "NCUI-101",
  ND: "CWR (Contribution and Wage Report)",
  OH: "QTR (Quarterly Tax Return)",
  OK: "OES-3",
  OR: "Form 132",
  PA: "Form UC-2A",
  RI: "QTWR (Quarterly Tax and Wage Report)",
  SC: "UCE-120",
  SD: "Form 21",
  TN: "LB-0851/0456",
  TX: "TWC - 3C",
  UT: "Form 33H",
  VT: "Form C-147",
  VA: "QPR (Quarterly Payroll Report)",
  WA: "Form 5208A/B",
  WV: "Unemployment Compensation Wage Report",
  WI: "UC-7823",
  WY: "UI/WC Summary Report",
};

export const WAGE_REPORT_LONG_NAMES = {
  AL: "State of Alabama Department of Industrial Relations Unemployment Compensation Division - Unemployment Tax Report",
  AK: "Alaska Quarterly Contribution Report (TQ01C)",
  AZ: "Arizona Department of Economic Security - Unemployment Tax and Wage Report (UC-018)",
  AR: "Employer's Quarterly Contribution Report (DWS-ARK-209B)",
  CA: "State of California - Employment Development Department Quarterly Contribution Return and Report of Wages (DE9C)",
  CO: "Colorado Department of Labor and Employment, Your Report of Individual Employee's Wages (UITR-1 + UITR-1a, both needed)",
  CT: "Connecticut Department of Labor, Employment Security Division - Employee Quarterly Earnings Report (UC-5A)",
  DC: "Employer's Quarterly Contribution and Wage Report (Form UC-30)",
  DE: "State of Delaware Unemployment Insurance - Quarterly Tax Report",
  FL: "Florida Department of Revenue Employer's Quarterly Report (RT-6)",
  GA: "Georgia Department of Labor - Employers Quarterly Tax and Wage Report (DOL-4N)",
  HI: "Employer's Quarterly Wage, Contribution and Employment and Training Assessment Report (Form UC-B6)",
  ID: "State of Idaho - Department of Labor, Unemployment Insurance Wage Report (TAX026)",
  IL: "Employer's Contribution and Wage Report - State of Illinois Department of Employment Security (UI 3/40)",
  IN: "Indiana Quarterly Payroll Report (UC-5A)",
  IA: "Iowa Workforce Development - Employer's Contribution and Payroll Report (65-5300)",
  KS: "Kansas Department of Labor - Quarterly Wage Report & Employment Tax Return (K CNS 100)",
  KY: "Division of Unemployment Insurance - Quarterly Wage Contribution Report",
  LA: "Louisiana Department of Revenue - Employer's Quarterly Wage & Tax Report (LWC ES-4)",
  ME: "Quarterly Income Tax Withholding and Unemployment Compensation Wages Listing (FormC1-ME)",
  MD: "Maryland Unemployment Insurance Quarterly Employment Report (DLLR/DUI-15/16)",
  MA: "Massachusetts Department of Revenue Employer's Quarterly Report of Wages Paid (WR-2)",
  MI: "State of Michigan, Department of Consumer & Industry Services Unemployment Agency - Wage Detail Report",
  MN: "Minnesota Department of Employment and Economic Development - Employer's Unemployment Quarterly Tax Report",
  MS: "Mississippi Department of Employment Security, (Form UI-3), Employers Quarterly Wage Report",
  MO: "Missouri Department of Labor & Industrial Relations Quarterly Wage Report (MODES-4-7)",
  MT: "Montana Employer's Unemployment Insurance (UI) Quarterly Wage Report (Form UI-5G)",
  NE: "State of Nebraska Department of Labor, Unemployment Insurance - Wage Report (UI-11W)",
  NV: "State of Nevada Department of Employment, Training, and Rehabilitation - Employer's Quarterly Contribution and Wage Report (NUCS4072)",
  NH: "NH Employment Security - Employer Quarterly Tax and Wage Report",
  NJ: "New Jersey Division of Revenue (WR-30)",
  NM: "NM Department of Workforce Solutions - Employer's Quarterly Wage and Contribution Report (ES903A)",
  NY: "Quarterly Combined Withholding, Wage Reporting, and Unemployment Insurance Return (NYS-45)",
  NC: "Employment Security Commission of North Carolina - Employer's Quarterly Tax and Wage Report NCUI-101",
  ND: "North Dakota Employer's Contribution and Wage Report",
  OH: "Ohio Department of Job and Family Services - Unemployment Compensation Quarterly Tax Return (OH JFS)",
  OK: "Oklahoma Employment Security Commission - Employers Quarterly Contribution Report",
  OR: "(Form 132) Unemployment Insurance Employee Detail Report",
  PA: "PA (Form UC-2A) Employer's Quarterly Report of Wages Paid to Each Employee",
  RI: "Quarterly Tax and Wage Report. Division of Taxation - Employer Tax Section",
  SC: "South Carolina Department of Revenue - Quarterly Contribution and Wage Report (UCE-120)",
  SD: "Employer's Quarterly Contribution, Investment Fee, and Wage Report (Form 21)",
  TN: "Tennessee Department of Labor and Workforce Development Premium Report (LB-0851/0456)",
  TX: "Texas Workforce Commission Unemployment Tax Services Employer's Quarterly Report (TWC - C3)",
  UT: "Utah Employer Quarterly Wage List and Contribution Report (Form 33H)",
  VT: "Vermont Employer's Quarterly Wage Report (Form C-147)",
  VA: "Virginia Employment Commission - Employer's Quarterly Payroll Report",
  WA: "Employment Security Department - Quarterly Wage Detail Report (Form 5208A/B)",
  WV: "West Virginia Unemployment Compensation - Wage Report",
  WI: "Wisconsin Division of Unemployment Insurance - Quarterly Wage Report UC-7823",
  WY: "Wyoming Quarterly UI/WC and UI Only Summary Report Form",
};

export const IMAGE_FILE_EXTENSIONS = [".jpg", ".gif", ".png", ".jpeg", ".bmp"];

export const PDF_FILE_EXTENSIONS = [".pdf"];

export const DOCUMENT_EXTENSIONS = [".pdf", ".doc", ".docx"];

export const DEFAULT_AGE_CURVE = {
  "0-20": 0.635,
  "21": 1.0,
  "22": 1.0,
  "23": 1.0,
  "24": 1.0,
  "25": 1.004,
  "26": 1.024,
  "27": 1.048,
  "28": 1.087,
  "29": 1.119,
  "30": 1.135,
  "31": 1.159,
  "32": 1.183,
  "33": 1.198,
  "34": 1.214,
  "35": 1.222,
  "36": 1.23,
  "37": 1.238,
  "38": 1.246,
  "39": 1.262,
  "40": 1.278,
  "41": 1.302,
  "42": 1.325,
  "43": 1.357,
  "44": 1.397,
  "45": 1.444,
  "46": 1.5,
  "47": 1.563,
  "48": 1.635,
  "49": 1.706,
  "50": 1.786,
  "51": 1.865,
  "52": 1.952,
  "53": 2.04,
  "54": 2.135,
  "55": 2.23,
  "56": 2.333,
  "57": 2.437,
  "58": 2.548,
  "59": 2.603,
  "60": 2.714,
  "61": 2.81,
  "62": 2.873,
  "63": 2.952,
  "64+": 3.0,
};

export const NY_AGE_CURVE = {
  "0-1000": 1,
};

export const AGE_CURVE = {
  MA: {
    "0-20": 0.751,
    "21": 1.183,
    "22": 1.183,
    "23": 1.183,
    "24": 1.183,
    "25": 1.183,
    "26": 1.183,
    "27": 1.22,
    "28": 1.25,
    "29": 1.275,
    "30": 1.287,
    "31": 1.305,
    "32": 1.323,
    "33": 1.334,
    "34": 1.346,
    "35": 1.352,
    "36": 1.358,
    "37": 1.363,
    "38": 1.369,
    "39": 1.381,
    "40": 1.393,
    "41": 1.41,
    "42": 1.427,
    "43": 1.45,
    "44": 1.478,
    "45": 1.511,
    "46": 1.55,
    "47": 1.593,
    "48": 1.641,
    "49": 1.688,
    "50": 1.741,
    "51": 1.792,
    "52": 1.847,
    "53": 1.902,
    "54": 1.961,
    "55": 2.019,
    "56": 2.08,
    "57": 2.142,
    "58": 2.206,
    "59": 2.28,
    "60": 2.365,
    "61": 2.365,
    "62": 2.365,
    "63": 2.365,
    "64": 2.365,
    "65+": 2.365,
  },
  NJ: {
    "0-20": 0.75,
    "21": 1.25,
    "22": 1.25,
    "23": 1.25,
    "24": 1.25,
    "25": 1.25,
    "26": 1.25,
    "27": 1.25,
    "28": 1.25,
    "29": 1.275,
    "30": 1.287,
    "31": 1.305,
    "32": 1.323,
    "33": 1.334,
    "34": 1.346,
    "35": 1.352,
    "36": 1.358,
    "37": 1.363,
    "38": 1.369,
    "39": 1.381,
    "40": 1.393,
    "41": 1.41,
    "42": 1.427,
    "43": 1.45,
    "44": 1.478,
    "45": 1.511,
    "46": 1.55,
    "47": 1.593,
    "48": 1.641,
    "49": 1.688,
    "50": 1.741,
    "51": 1.792,
    "52": 1.847,
    "53": 1.902,
    "54": 1.961,
    "55": 2.019,
    "56": 2.08,
    "57": 2.142,
    "58": 2.206,
    "59": 2.28,
    "60": 2.28,
    "61": 2.28,
    "62": 2.28,
    "63": 2.28,
    "64": 2.28,
    "65+": 2.28,
  },
  DC: {
    "0-20": 0.654,
    "20": 0.654,
    "21": 0.727,
    "22": 0.727,
    "23": 0.727,
    "24": 0.727,
    "25": 0.727,
    "26": 0.727,
    "27": 0.727,
    "28": 0.744,
    "29": 0.76,
    "30": 0.779,
    "31": 0.799,
    "32": 0.817,
    "33": 0.836,
    "34": 0.856,
    "35": 0.876,
    "36": 0.896,
    "37": 0.916,
    "38": 0.927,
    "39": 0.938,
    "40": 0.975,
    "41": 1.013,
    "42": 1.053,
    "43": 1.094,
    "44": 1.137,
    "45": 1.181,
    "46": 1.227,
    "47": 1.275,
    "48": 1.325,
    "49": 1.377,
    "50": 1.431,
    "51": 1.487,
    "52": 1.545,
    "53": 1.605,
    "54": 1.668,
    "55": 1.733,
    "56": 1.801,
    "57": 1.871,
    "58": 1.944,
    "59": 2.02,
    "60": 2.099,
    "61": 2.181,
    "62": 2.181,
    "63": 2.181,
    "64+": 2.181,
  },
  UT: {
    "0-20": 0.793,
    "21": 1.0,
    "22": 1.05,
    "23": 1.113,
    "24": 1.191,
    "25": 1.298,
    "26": 1.363,
    "27": 1.39,
    "28": 1.39,
    "29": 1.39,
    "30": 1.39,
    "31": 1.39,
    "32": 1.39,
    "33": 1.39,
    "34": 1.39,
    "35": 1.39,
    "36": 1.39,
    "37": 1.404,
    "38": 1.425,
    "39": 1.45,
    "40": 1.479,
    "41": 1.516,
    "42": 1.562,
    "43": 1.616,
    "44": 1.681,
    "45": 1.748,
    "46": 1.818,
    "47": 1.891,
    "48": 1.966,
    "49": 2.045,
    "50": 2.127,
    "51": 2.212,
    "52": 2.3,
    "53": 2.392,
    "54": 2.488,
    "55": 2.588,
    "56": 2.691,
    "57": 2.799,
    "58": 2.911,
    "59": 3.0,
    "60": 3.0,
    "61": 3.0,
    "62": 3.0,
    "63": 3.0,
    "64+": 3.0,
  },
  MN: {
    "0-20": 0.89,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  AK: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  AL: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  AR: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  AZ: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  CA: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  CO: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  CT: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  DE: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  FL: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  GA: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  IA: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  ID: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  IL: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  IN: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  KS: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  KY: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  LA: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  MD: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  ME: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  MI: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  MO: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  MS: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  MT: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  NC: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  ND: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  NE: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  NH: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  NM: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  NV: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  NY: {
    "0-1000": 1,
  },
  OH: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  OK: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  OR: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  PA: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  RI: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  SC: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  SD: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  TN: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  TX: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  VA: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  VT: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  WA: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  WI: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  WV: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
  WY: {
    "0-20": 0.635,
    "21": 1.0,
    "22": 1.0,
    "23": 1.0,
    "24": 1.0,
    "25": 1.004,
    "26": 1.024,
    "27": 1.048,
    "28": 1.087,
    "29": 1.119,
    "30": 1.135,
    "31": 1.159,
    "32": 1.183,
    "33": 1.198,
    "34": 1.214,
    "35": 1.222,
    "36": 1.23,
    "37": 1.238,
    "38": 1.246,
    "39": 1.262,
    "40": 1.278,
    "41": 1.302,
    "42": 1.325,
    "43": 1.357,
    "44": 1.397,
    "45": 1.444,
    "46": 1.5,
    "47": 1.563,
    "48": 1.635,
    "49": 1.706,
    "50": 1.786,
    "51": 1.865,
    "52": 1.952,
    "53": 2.04,
    "54": 2.135,
    "55": 2.23,
    "56": 2.333,
    "57": 2.437,
    "58": 2.548,
    "59": 2.603,
    "60": 2.714,
    "61": 2.81,
    "62": 2.873,
    "63": 2.952,
    "64+": 3.0,
  },
};

export const PROVIDER_APPLICATION_URLS = {
  "AARP by Aetna": {
    national: "http://premierhealthcoverage.com/apply_now.aspx",
  },
  Aetna: {
    national: "https://www51.aetna.com/iqs/ipsRedirect.do?action=viewBrokerLink&bid=zHL7Ae1LQ5I%3d&LoggedInUserId=zHL7Ae1LQ5I%3d&ipsRole=b7K7%2f97acLo%3d",
  },
  Amerihealth: {
    NJ: "https://amerihealth.inshealth.com/?allid=Ame27848",
  },
  "Assurant Health": {
    WA: "https://consumer.eassuranthealth.com/IM/Consumer/EASE/Demographics/StartQuote",
  },
  "Anthem Blue Cross": {
    CA: "https://pd.secure.anthem.com/AgentConnect/gen/link.htm?linkid=jGkfN_CnMOfbvqQ0n_gzbvt20094722432349",
  },
  "Blue Shield": {
    CA: "https://www.blueshieldca.com/bsca/ApplyNow?xyz=JuMw%2FZy9p2jj",
    IL: "https://retailweb.hcsc.net/retailshoppingcart/IL/census",
    TX: "https://osc.hscil.com/tx/Quoting/Applicants.aspx?type=1&WT.svl=Banner&msq=false&source=WGTX700720",
    WA: "http://www.regence.com/individual/medical/index.jsp",
  },
  "CareFirst BlueChoice": {
    DC: "http://www.carefirst.com/individual/index.html",
  },
  "CareFirst BlueCross BlueShield": {
    DC: "http://www.carefirst.com/individual/index.html",
  },
  Celtic: {
    national: "https://celtic.inshealth.com/ehi/Alliance?allid=Cel26959&sid=InteriorButtonNoPromo",
  },
  CeltiCare: {
    MA: "https://www.mahealthconnector.org/portal/site/connector/template.PAGE/menuitem.55b6e23ac6627f40dbef6f47d7468a0c",
  },
  Cigna: {
    national: "https://secure.getcigna.com/page.php?s=home&p=home/index.php&broker_id=CIG401376",
  },
  "Coventry Health": {
    national: "http://coventryone.coventryhealthcare.com/",
  },
  "Easy Choice NY": {
    NY: "http://www.ehealthinsurance.com/health-insurance-companies/",
  },
  EmblemHealth: {
    NY: "http://www.emblemhealth.com/DEFAULT.ASPX?PAGE=48_zip",
  },
  "Empire HealthChoice": {
    NY: "https://buyhealthinsurance.empireblue.com/pf/index.jsp?null",
  },
  Fallon: {
    MA: "http://www.ehealthinsurance.com/health-insurance-companies/fallon-massachusetts/",
  },
  "Group Health Cooperative": {
    WA: "https://ghc.inshealth.com/?allid=Gro21010",
  },
  "Group Health Options": {
    WA: "https://ghc.inshealth.com/?allid=Gro21010",
  },
  "Horizon BCBS": {
    NJ: "https://horizon.healthconnectsystems.com/IFP/IFPQuote.aspx?uc=121301",
  },
  Humana: {
    national: "https://www.humana-one.com/secured/individual-health-insurance-quotes.aspx",
  },
  "IHC Group": {
    national: "http://www.ehealthinsurance.com/health-insurance-companies/companion-illinois/",
  },
  "Kaiser Permanente": {
    national:
      "https://kaiser.healthinsurance-asp.com/expressweb/user/URLDecryptAction.action?refID=-4hjk4fuxh4jvfrramrpzk2lbkkyrq4l6q2r3isxpg373rxbkdux945nmu14mzq&selectedPlanId=&zipCode=#4",
  },
  LifeWise: {
    WA: "https://lwwa.inshealth.com/?allid=Lif25311",
  },
  "MVP Health Care": {
    NY: "http://www.ehealthinsurance.com/health-insurance-companies/mvp-new-york/",
  },
  Oxford: {
    NY: "http://www.ehealthinsurance.com/health-insurance-companies/oxford-new-york/",
    NJ: "http://www.ehealthinsurance.com/health-insurance-companies/oxford-new-jersey/",
  },
  "Scott & White": {
    TX: "https://swhp.inshealth.com/?allid=Sco27958",
  },
  UnitedHealthOne: {
    national: "https://www.uhone.com/Quote/QuoteCensus.mvc",
  },
  "Health Net": {
    national: "https://www.healthnet.com/quotes?a=108137",
  },
};

export const COMPARE_TERMS_AND_CATEGORIES = [
  [
    "Plan Overview",
    [
      ["Plan Type", "Plan Network"],
      ["Annual Deductible", "Deductible"],
      ["Annual Out-of-Pocket Limit", ""],
      ["Coinsurance", "Coinsurance"],
      ["Separate Prescription Drugs Deductible", "Drug Deductible"],
      ["Lifetime Maximum", ""],
      ["Health Savings Account (HSA) Eligible", "HSA Eligible"],
      ["Application Fee", ""],
    ],
    true,
    "plan_overview",
  ],
  [
    "Doctor Visits",
    [
      ["Office Visit for Primary Doctor", "Office Visit"],
      ["Office Visit for Specialist", "Specialist Visit"],
      ["Primary Care Physician (PCP) Required", "Primary Care Doctor Required"],
      ["Specialist Referrals Required", ""],
    ],
    false,
    "physician_restrictions",
  ],
  [
    "Prescription Drugs",
    [
      ["Separate Prescription Drugs Deductible", "Drug Deductible"],
      ["Generic Prescription Drugs", "Generic Drugs"],
      ["Brand Prescription Drugs", "Brand Drugs"],
      ["Non-Formulary Prescription Drugs Coverage", "Non-Formulary Drugs"],
    ],
    false,
    "prescription_drugs",
  ],
  [
    "Preventive Care",
    [
      ["Periodic Health Exam", "Annual Physical"],
      ["Periodic OB-GYN Exam", "Annual OB/GYN Checkup"],
      ["Well Baby Care", ""],
    ],
    false,
    "preventative_care",
  ],
  [
    "Hospital Coverage",
    [
      ["Emergency Room", ""],
      ["Outpatient Lab/X-Ray", "Labs, Tests, and Scans"],
      ["Outpatient Surgery", ""],
      ["Hospitalization", ""],
    ],
    false,
    "hospital_coverage",
  ],
  [
    "Out of Network Coverage",
    [
      ["Out-of-Network Coverage", "Out of Network Coverage"],
      ["Out-of-Network Authorization Required", ""],
      ["Out-of-Network Deductible", ""],
      ["Out-of-Network Coinsurance", ""],
      ["Out-of-Network Out-of-Pocket Limit", ""],
      ["Out of Country Coverage", "Out of Country Coverage"],
    ],
    false,
    "out_of_network_coverage",
  ],
  [
    "Additional Coverage",
    [
      ["Chiropractic Coverage", "Chiropractic"],
      ["Mental Health Coverage", "Mental Health"],
      ["Substance Abuse Coverage", "Substance Abuse"],
      ["Pre & Postnatal Office Visit", "Pre & Post Natal Office Visits"],
      ["Labor & Delivery Hospital Stay", "Labor & Delivery Hospital Stay"],
    ],
    false,
    "additional_coverage",
  ],
];

export const FINE_PRINT_LABELS = [
  ["overview", "Overview"],
  ["doctorVisits", "Doctors"],
  ["prescriptionDrugs", "Prescriptions"],
  ["emergencies", "Emergencies"],
  ["hospitalCoverage", "Hospitalization"],
  ["pregnancyRelated", "Pregnancy"],
  ["labsTestsScans", "Tests & Scans"],
  ["other", "Other"],
];

export const FINE_PRINT_SECTIONS = {
  overview: [
    {
      label: "Office Visit",
      key: "pcp_visit",
    },
    {
      label: "Specialist Visit",
      key: "specialist_visit",
    },
    {
      label: "Generic Drugs",
      key: "generic_drugs",
    },
    {
      label: "Brand Drugs",
      key: "brand_drugs",
    },
    {
      label: "Emergency Room",
      key: "emergency_room",
    },
    {
      label: "Hospitalization",
      key: "hospitalization",
    },
  ],
  doctorVisits: [
    {
      label: "Office Visit",
      key: "pcp_visit",
    },
    {
      label: "Specialist Visit",
      key: "specialist_visit",
    },
    {
      label: "Annual Physical",
      key: "periodic_exam",
    },
    {
      label: "Annual OB/GYN Checkup",
      key: "obgyn_exam",
    },
    {
      label: "Well Baby Care",
      key: "baby_care",
    },
  ],
  prescriptionDrugs: [
    {
      label: "Generic Drugs",
      key: "generic_drugs",
    },
    {
      label: "Brand Drugs",
      key: "brand_drugs",
    },
    {
      label: "Drug Deductible",
      key: "separate_rx_deductible",
    },
  ],
  emergencies: [
    {
      label: "Emergency Room",
      key: "emergency_room",
    },
    {
      label: "Ambulance",
      key: "ambulance",
    },
    {
      label: "Urgent Care",
      key: "urgent_care",
    },
  ],
  hospitalCoverage: [
    {
      label: "Hospitalization",
      key: "hospitalization",
    },
    {
      label: "Outpatient Surgery Facility",
      key: "surgery",
    },
    {
      label: "Outpatient Surgery Staff",
      key: "surgery_staff",
    },
    {
      label: "Physical Therapy",
      key: "physical_therapy",
    },
  ],
  pregnancyRelated: [
    {
      label: "Labor & Delivery Staff",
      key: "labor",
    },
    {
      label: "Labor & Delivery Facility",
      key: "labor_facility",
    },
    {
      label: "Pre & Post Natal Visits",
      key: "prenatal_office_visit",
    },
    {
      label: "Infertility",
      key: "infertility",
    },
  ],
  labsTestsScans: [
    {
      label: "X-Ray",
      key: "xray",
    },
    {
      label: "MRI/CT/PET",
      key: "mri",
    },
    {
      label: "Labs and Tests",
      key: "labs",
    },
  ],
  other: [
    {
      label: "Chiropractic",
      key: "chiropractic",
    },
    {
      label: "Mental Health",
      key: "mental_health",
    },
    {
      label: "Substance Abuse",
      key: "substance_abuse",
    },
  ],
};

export const CLEAN_PLAN_TERMS = {
  "Office Visit for Primary Doctor": [
    "<ul><li><span>$45 copay for 3 three visits</span></li><li><span>then full price until deductible</span></li><li><span>then 35% of cost until maximum</span></li></ul>",
    "$30 copay",
    "$30 copay",
    "$10 copay",
  ],
  "Office Visit for Specialist": [
    "<ul><li><span>$45 copay for 3 three visits</span></li><li><span>then full price until deductible</span></li><li><span>then 35% of cost until maximum</span></li></ul>",
    "$30 copay",
    "$30 copay",
    "$10 copay",
  ],
  "Periodic Health Exam": ["Included", "Included", "Included", "Included"],
  "Periodic OB-GYN Exam": ["Included", "Included", "Included", "Included"],
  "Well Baby Care": ["Included", "Included", "Included", "Included"],
  "Prescription Drugs": ["", "", "", ""],
  "Separate Prescription Drugs Deductible": [
    "$250 for brand & non-formulary drugs",
    "$200 for brand & non-formulary drugs",
    "$200 for brand & non-formulary drugs",
    "None",
  ],
  "Generic Prescription Drugs": ["$15 copay", "$10 copay", "$10 copay", "$10 copay"],
  "Brand Prescription Drugs": ["$30 or 30% whichever is greater", "$35 copay after drug deductible", "$35 copay after drug deductible", "$25 copay"],
  "Non-Formulary Prescription Drugs Coverage": ["Not Covered", "50% after drug deductible", "50% after drug deductible", "$50 copay + 10% until maximum"],
  "Mail Order for Prescription Drugs": [
    "Generic: $30, Brand: $60 or 30% whichever is greater, Non-formulary: Not Covered",
    "Generic: $10, Brand: $35 copay after drug deductible, Non-Forumulary: 50% after drug deductible",
    "Generic: $10, Brand: $35 copay after drug deductible, Non-Forumulary: 50% after drug deductible",
    "Generic: $10, Brand: $25, Non-formulary: $50 + 10% until maximum",
  ],
  "Chiropractic Coverage": [
    "<ul><li><span>Full price until deductible</span></li><li><span>then 35% until maximum</span></li><li><span>12 visits maximum per year</span></li></ul>",
    "<ul><li><span>Full price until deductible</span></li><li><span>30 visits maximum per year</span></li></ul>",
    "<ul><li><span>Full price until deductible</span></li><li><span>30 visits maximum per year</span></li></ul>",
    "<ul><li><span>$10 copay</span></li><li><span> 12 visits maximum per year</span></li></ul>",
  ],
  "Mental Health Coverage": [
    "<ul><li><span>Full price until deductible</span></li><li><span>then 50% until maximum</span></li><li><span>20 visits maximum per year</span></li></ul>",
    "<ul><li><span>Full price until deductible</span></li><li><span>30 visits maximum per year</span></li></ul>",
    "<ul><li><span>Full price until deductible</span></li><li><span>30 visits maximum per year</span></li></ul>",
    "<ul><li><span>10% until maximum</span></li><li><span>30 visits maximum per year</span></li></ul>",
  ],
  "Substance Abuse Coverage": [
    "<ul><li><span>Full price until deductible</span></li><li><span>then 50% until maximum</span></li><li><span>20 visits maximum per year</span></li></ul>",
    "<ul><li><span>Full price until deductible</span></li><li><span>30 visits maximum per year</span></li></ul>",
    "<ul><li><span>Full price until deductible</span></li><li><span>30 visits maximum per year</span></li></ul>",
    "<ul><li><span>10% until maximum</span></li><li><span>30 visits maximum per year</span></li></ul>",
  ],
  "Outpatient Surgery": [
    "Full price until deductible,<br/> then 35% until maximum",
    "Full price until deductible",
    "Full price until deductible",
    "10% until maximum",
  ],
  Hospitalization: [
    "<ul><li><span>Full price + $1000 copay until deductible</span></li><li><span>then 35% + $1000 copay until maximum</span></li></ul>",
    "Full price until deductible",
    "Full price until deductible",
    "10% until maximum",
  ],
  "Outpatient Lab/X-Ray": [
    "Full price until deductible, then 35% until maximum",
    "Full price until deductible",
    "Full price until deductible",
    "10% until maximum",
  ],
  "Emergency Room": [
    "<ul><li><span>Full price + $100 copay until deductible</span></li><li><span>then 35% + $100 copay until maximum</span></li></ul>",
    "$250 copay",
    "$250 copay",
    "$100 copay + 10% until maximum",
  ],
  "Ambulance Services": [
    "Full price until deductible, then 35% until maximum",
    "Full price until deductible",
    "Full price until deductible",
    "$50 copay + 10% until maximum",
  ],
  "Urgent Care Centers": ["Full price until deductible, then 35% until maximum", "$150 copay", "$150 copay", "$50 copay + 10% until maximum"],
  "Pre & Postnatal Office Visit": [
    "Full price until deductible, then 35% until maximum",
    "Full price until deductible",
    "Full price until deductible",
    "10% until maximum",
  ],
  "Labor & Delivery Hospital Stay": [
    "Full price until deductible, then 35% until maximum",
    "Full price until deductible",
    "Full price until deductible",
    "10% until maximum",
  ],
};

export const COLORED_DOTS = [
  [
    "Office Visits:",
    [
      ["Doctor Visit", ["yellow", "green", "green", "green"]],
      ["Specialist Visit", ["red", "green", "green", "green"]],
    ],
  ],
  [
    "Prescription Drugs:",
    [
      ["Generic", ["green", "green", "green", "green"]],
      ["Brand", ["red", "green", "green", "green"]],
    ],
  ],
  [
    "Hospital Services:",
    [
      ["Emergency Room", ["red", "green", "green", "yellow"]],
      ["Lab Work & Tests", ["red", "yellow", "yellow", "green"]],
      ["X-Rays & Scans", ["red", "yellow", "yellow", "green"]],
      ["Hospitalization", ["red", "red", "red", "green"]],
    ],
  ],
  [
    "Pregnancy:",
    [
      ["Pre- & Post-natal Care:", ["red", "red", "red", "green"]],
      ["Labor & Delivery", ["red", "red", "red", "green"]],
    ],
  ],
  [
    "Out-of-Network:",
    [
      ["Out of Network:", ["red", "green", "green", "green"]],
      ["Out of Country:", ["yellow", "yellow", "yellow", "yellow"]],
    ],
  ],
  [
    "Additional Services:",
    [
      ["Chiropractic", ["red", "red", "red", "green"]],
      ["Mental Health", ["red", "red", "red", "green"]],
      ["Substance Abuse", ["red", "red", "red", "green"]],
    ],
  ],
];

export const DEFAULT_RAF = 1.1;

export const DOCTOR_SEARCH_URLS = {
  united_healthcare: "https://connect.werally.com/plans/uhc/1",
  bcbstx: "https://public.hcsc.net/providerfinder/search.do?corpEntCd=TX1&nextPage=networkplan&residencestate=",
  humana: "https://www.humana.com/finder/search?customerId=1",
  premera_blue_cross: "https://premera.vitalschoice.com/?ci=premerawa&network_id=21&_ga=2.20146171.276375202.1498241853-1090884365.1498241853",
  aetna: "http://www.aetna.com/dse/search?site_id=dse",
  anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria",
  kaiser: "https://healthy.kaiserpermanente.org/doctors-locations",
  bcbsil: "https://public.hcsc.net/providerfinder/search.do?corpEntCd=IL1&nextPage=networkplan&residencestate=",
  careconnect: "https://www.careconnect.com/find-resources/provider-search/",
  group_health: "https://healthy.kaiserpermanente.org/doctors-locations",
  horizon_bcbs: "http://doctorfinder.horizonblue.com/",
  blue_shield: "https://www.blueshieldca.com/fap/app/find-a-doctor.html",
  oxford: "https://www.oxhp.com/secure/physician/oxhealth_search_doctor.html",
  independence_bc: "https://ibxweb.healthsparq.com/healthsparq/public/#/one/city=Philadelphia&state",
  amerihealth:
    "https://ibxweb.healthsparq.com/healthsparq/public/#/one/city=Philadelphia&state=PA&country=&insurerCode=IBXRED_I&brandCode=IBXREDAHPA&productCode=856",
  bcbsma: "https://www.bluecrossma.com/wps/portal/members/using-my-plan/doctors-hospitals/findadoctor/",
  sharp: "https://www.sharphealthplan.com/search",
  carefirst_bcbs: "https://member.carefirst.com/mos/#/fadpublic/search/standard",
};

export const PROVIDER_SEARCH_LINKS = {
  CA: {
    health_net: "https://www.healthnet.com/portal/providerSearch.do",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    sharp: "",
    kaiser: "https://healthy.kaiserpermanente.org/health/care/consumer/locate-our-services/doctors-and-locations",
    anthem: "https://www.anthem.com/ca/health-insurance/provider-directory/searchcriteria?branding=ABC",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    see_change: "http://www.cigna.com/web/public/hcpdirectory",
  },
  CO: {
    humana: "https://www.humana.com/finder/search?customerId=1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    kaiser: "https://healthy.kaiserpermanente.org/health/care/consumer/locate-our-services/doctors-and-locations",
  },
  CT: {
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    connecticare: "",
    oxford: "https://www.oxhp.com/secure/providerSearch/content_doctor.html",
  },
  FL: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    avmed: "http://avmed.prismisp.com/?tab=doctor&plan=1&visitor=member",
    humana: "https://www.humana.com/finder/search?customerId=1",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    bcbs: "http://myportal.bcbsfl.com/wps/portal/opd",
  },
  GA: {
    kaiser: "https://healthy.kaiserpermanente.org/health/care/consumer/locate-our-services/doctors-and-locations",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    bcbs: "",
    humana: "https://www.humana.com/finder/search?customerId=1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  HI: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  IL: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    bcbsil: "https://public.hcsc.net/providerfinder/search.do?corpEntCd=IL1",
    humana: "https://www.humana.com/finder/search?customerId=1",
  },
  IN: {
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    humana: "https://www.humana.com/finder/search?customerId=1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  MA: {
    harvard_pilgrim: "https://www.providerlookuponline.com/harvardpilgrim/po7/Search.aspx",
    tufts: "http://tuftshealthplan.prismisp.com/?WT.mc_id=members_leftnav_doctor_search&WT.mc_ev=click",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    bcbsma: "https://findadoctor.bluecrossma.com/",
  },
  MD: {
    carefirst_bcbs: "",
    coventry: "",
    kaiser: "https://healthy.kaiserpermanente.org/health/care/consumer/locate-our-services/doctors-and-locations",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  NJ: {
    oxford: "https://www.oxhp.com/secure/providerSearch/content_doctor.html",
    horizon_bcbs: "",
    amerihealth: "",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    health_republic: "http://network-nj.healthrepublic.us/FindADoctor/FindADoctor_HRICoOpMain.aspx",
  },
  NV: {
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
  },
  NY: {
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    emblem_health: "http://www.emblemhealth.com/find-a-doctor/directory",
    oxford: "https://www.oxhp.com/secure/providerSearch/content_doctor.html",
    health_republic: "http://newyork.healthrepublic.us/providerdirectory/",
  },
  OH: {
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    medical_mutual: "",
  },
  OR: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    pacific_source: "",
    health_net: "https://www.healthnet.com/portal/providerSearch.do",
    regence: "",
  },
  TX: {
    humana: "https://www.humana.com/finder/search?customerId=1",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    memorial_hermann: "http://www.memorialhermann.org/find-a-doctor/",
    bcbstx: "https://public.hcsc.net/providerfinder/search.do?corpEntCd=TX1&WT.svl=FADButton",
  },
  VA: {
    kaiser: "https://healthy.kaiserpermanente.org/health/care/consumer/locate-our-services/doctors-and-locations",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  WA: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    group_health: "",
    regence: "",
    premera_blue_cross:
      "https://healthsearch.eproviderdirectory.com/?PlanId=premera&ProductId=premerawa&BrandingId=premera&DirectoryType=provider&NetworkID=ALL&QSCorrected=Y234JU",
  },
  WI: {
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    humana: "https://www.humana.com/finder/search?customerId=1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  DC: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    kaiser: "https://healthy.kaiserpermanente.org/health/care/consumer/locate-our-services/doctors-and-locations",
    carefirst_bcbs: "",
  },
  NH: {
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    harvard_pilgrim: "https://www.providerlookuponline.com/harvardpilgrim/po7/Search.aspx",
    minuteman: "https://www.minutemanhealthdirect.org/Provider_Search/Default.aspx",
  },
  MO: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
  },
  MI: {
    priority_health: "",
    united_healthcare: "",
    bcbsmi: "",
  },
  KY: {
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
    humana: "https://www.humana.com/finder/search?customerId=1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  LA: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    humana: "https://www.humana.com/finder/search?customerId=1",
  },
  NC: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
  },
  PA: {
    aetna: "",
    independence_bc: "",
    highmark: "",
    coventry: "",
    united_healthcare: "",
  },
  OK: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    bcbsok: "",
  },
  KS: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
  },
  TN: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    humana: "https://www.humana.com/finder/search?customerId=1",
  },
  AL: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  AR: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  AZ: {
    humana: "https://www.humana.com/finder/search?customerId=1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  UT: {
    humana: "https://www.humana.com/finder/search?customerId=1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  SC: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  IA: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  MS: {
    humana: "https://www.humana.com/finder/search?customerId=1",
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  WY: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  MT: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  DE: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
  },
  RI: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  NM: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  NE: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  ID: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
  },
  WV: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
  },
  ME: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
    anthem: "https://www.anthem.com/health-insurance/provider-directory/searchcriteria?qs=*7j/ZrdO02D7VTuocyuzY9Q==&brand=abcbs",
  },
  AK: {
    united_healthcare: "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
    aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
  },
};

export const PROVIDER_SEARCH_LINKS_OLD = {
  Aetna: "http://www.aetna.com/dse/search?site_id=docfind&langpref=en&tabKey=tab1",
  "Anthem Blue Cross": "https://www.anthem.com/ca/health-insurance/provider-directory/searchcriteria?branding=ABC",
  AvMed: "http://avmed.prismisp.com/?tab=doctor&plan=1&visitor=member",
  BCBS: "http://myportal.bcbsfl.com/wps/portal/opd",
  "Blue Cross Blue Shield": "https://public.hcsc.net/providerfinder/search.do?corpEntCd=TX1&WT.svl=FADButton",
  "Blue Shield": "https://www.blueshieldca.com/fap/app/search.html",
  "Blue Cross Blue Shield MA": "https://findadoctor.bluecrossma.com/",
  Cigna: "http://www.cigna.com/web/public/hcpdirectory",
  EmblemHealth: "http://www.emblemhealth.com/find-a-doctor/directory",
  "Empire BCBS": "https://www.empireblue.com/health-insurance/provider-directory/searchcriteria&brand=ebcbs",
  "Excellus BCBS": "https://www.excellusbcbs.com/wps/portal/xl/mbr/fnd/doctor",
  "Harvard Pilgrim": "https://www.providerlookuponline.com/harvardpilgrim/po7/Search.aspx",
  "Health Net": "https://www.healthnet.com/portal/providerSearch.do",
  "Health Republic": "http://newyork.healthrepublic.us/providerdirectory/",
  "HealthPass/Health Republic": "http://newyork.healthrepublic.us/providerdirectory/",
  Humana: "https://www.humana.com/finder/search?customerId=1",
  "Kaiser Permanente": "https://healthy.kaiserpermanente.org/health/care/consumer/locate-our-services/doctors-and-locations",
  "Oxford Freedom": "https://www.oxhp.com/secure/providerSearch/content_doctor.html",
  "Oxford Liberty": "https://www.oxhp.com/secure/providerSearch/content_doctor.html",
  "See Change": "http://www.cigna.com/web/public/hcpdirectory",
  "Tufts Health Plan": "http://tuftshealthplan.prismisp.com/?WT.mc_id=members_leftnav_doctor_search&WT.mc_ev=click",
  "United Healthcare": "https://www.providerlookuponline.com/UHC/po7/Search.aspx",
};

export const ZIP_CODES_BY_STATE_REGION = {
  CA: {
    "1": ["95961"],
    "2": ["94558"],
    "3": ["95630"],
    "4": ["94112"],
    "5": ["94565"],
    "6": ["94587"],
    "7": ["95035"],
    "8": ["94080"],
    "9": ["95076"],
    "10": ["95307"],
    "11": ["93230"],
    "12": ["93033"],
    "13": ["92328"],
    "14": ["93307"],
    "15": ["90650"],
    "16": ["91331"],
    "17": ["92336"],
    "18": ["92683"],
    "19": ["92154"],
  },
  NY: {
    "1": ["12028"],
    "2": ["14027"],
    "3": ["10919"],
    "4": ["10016"],
    "5": ["14428"],
    "6": ["13746"],
    "7": ["12858"],
    "8": ["11550"],
  },
  NJ: {
    "1": ["07030"],
    "2": ["07072"],
    "3": ["07440"],
    "4": ["07979"],
    "5": ["08029"],
    "6": ["08051"],
  },
  FL: {
    "1": ["32608"],
    "2": ["32063"],
    "3": ["32404"],
    "4": ["32091"],
    "5": ["32935"],
    "6": ["33311"],
    "7": ["32424"],
    "8": ["33952"],
    "9": ["34465"],
    "10": ["32073"],
    "11": ["34112"],
    "12": ["32055"],
    "13": ["34266"],
    "14": ["32680"],
    "15": ["32210"],
    "16": ["32514"],
    "17": ["32137"],
    "18": ["32320"],
    "19": ["32351"],
    "20": ["32693"],
    "21": ["33471"],
    "22": ["32456"],
    "23": ["32052"],
    "24": ["33873"],
    "25": ["33440"],
    "26": ["34609"],
    "27": ["33825"],
    "28": ["33594"],
    "29": ["32425"],
    "30": ["32958"],
    "31": ["32446"],
    "32": ["32344"],
    "33": ["32066"],
    "34": ["34711"],
    "35": ["33912"],
    "36": ["32308"],
    "37": ["32696"],
    "38": ["32321"],
    "39": ["32340"],
    "40": ["34209"],
    "41": ["34471"],
    "42": ["34997"],
    "43": ["33012"],
    "44": ["33040"],
    "45": ["32034"],
    "46": ["32547"],
    "47": ["34974"],
    "48": ["32822"],
    "49": ["34741"],
    "50": ["33411"],
    "51": ["34668"],
    "52": ["34698"],
    "53": ["33813"],
    "54": ["32177"],
    "55": ["32561"],
    "56": ["34232"],
    "57": ["32765"],
    "58": ["32082"],
    "59": ["34952"],
    "60": ["34785"],
    "61": ["32060"],
    "62": ["32347"],
    "63": ["32054"],
    "64": ["32174"],
    "65": ["32327"],
    "66": ["32433"],
    "67": ["32428"],
  },
  TX: {
    "1": ["76443"],
    "2": ["79012"],
    "3": ["73301"],
    "4": ["77374"],
    "5": ["78520"],
    "6": ["76629"],
    "7": ["78330"],
    "8": ["75001"],
    "9": ["79821"],
    "10": ["77001"],
    "11": ["76501"],
    "12": ["78040"],
    "13": ["75601"],
    "14": ["79322"],
    "15": ["78501"],
    "16": ["79701"],
    "17": ["76820"],
    "18": ["76883"],
    "19": ["75020"],
    "20": ["75411"],
    "21": ["75103"],
    "22": ["77901"],
    "23": ["75838"],
    "24": ["76228"],
    "25": ["75007"],
    "26": ["77053"],
    "27": ["77301"],
  },
  VA: {
    "1": ["24060"],
    "2": ["22902"],
    "3": ["24541"],
    "4": ["22801"],
    "5": ["24201"],
    "6": ["24502"],
    "7": ["23114"],
    "8": ["24153"],
    "9": ["23452"],
    "10": ["22350"],
    "11": ["22604"],
    "12": ["24589"],
  },
  MD: {
    "1": ["21234"],
    "2": ["21921"],
    "3": ["20906"],
    "4": ["21740"],
  },
  NH: {
    "1": ["03087"],
  },
  GA: {
    "1": ["31705"],
    "2": ["30606"],
    "3": ["30043"],
    "4": ["30117"],
    "5": ["30906"],
    "6": ["31525"],
    "7": ["30736"],
    "8": ["31907"],
    "9": ["30721"],
    "10": ["30506"],
    "11": ["31021"],
    "12": ["31088"],
    "13": ["30701"],
    "14": ["31419"],
    "15": ["31602"],
    "16": ["31061"],
  },
  IN: {
    "1": ["46308"],
    "2": ["46514"],
    "3": ["46791"],
    "4": ["46835"],
    "5": ["47980"],
    "6": ["46914"],
    "7": ["47909"],
    "8": ["47304"],
    "9": ["47804"],
    "10": ["46227"],
    "11": ["47375"],
    "12": ["47202"],
    "13": ["46142"],
    "14": ["47025"],
    "15": ["47591"],
    "16": ["47151"],
    "17": ["47630"],
  },
  OH: {
    "1": ["43615"],
    "2": ["45840"],
    "3": ["45404"],
    "4": ["45011"],
    "5": ["45103"],
    "6": ["44870"],
    "7": ["44906"],
    "8": ["43338"],
    "9": ["43055"],
    "10": ["45628"],
    "11": ["44035"],
    "12": ["44215"],
    "13": ["44512"],
    "14": ["44677"],
    "15": ["44646"],
    "16": ["43701"],
    "17": ["45701"],
  },
  WA: {
    "1": ["98063"],
    "2": ["98643"],
    "3": ["98639"],
    "4": ["99173"],
    "5": ["98508"],
    "6": ["98930"],
    "7": ["98862"],
    "8": ["98220"],
    "9": ["99163"],
  },
  CO: {
    "1": ["80025"],
    "2": ["80918"],
    "3": ["80013"],
    "4": ["80525"],
    "5": ["81504"],
    "6": ["80634"],
    "7": ["81001"],
    "8": ["81212"],
    "9": ["81157"],
  },
  OR: {
    "1": ["97007"],
    "2": ["97402"],
    "3": ["97301"],
    "4": ["97701"],
    "5": ["97420"],
    "6": ["97838"],
    "7": ["97504"],
  },
  CT: {
    "1": ["06902"],
    "2": ["06010"],
    "3": ["06790"],
    "4": ["06459"],
    "5": ["06516"],
    "6": ["06360"],
    "7": ["06268"],
    "8": ["06331"],
  },
  NV: {
    "1": ["89110"],
    "2": ["89502"],
    "3": ["89701"],
    "4": ["89406"],
  },
  MA: {
    "1": ["01103"],
    "2": ["01605"],
    "3": ["02019"],
    "4": ["01852"],
    "5": ["02119"],
    "6": ["02745"],
    "7": ["02532"],
  },
  WI: {
    "1": ["53215"],
    "2": ["53711"],
    "3": ["54016"],
    "4": ["54703"],
    "5": ["54880"],
    "6": ["54601"],
    "7": ["53818"],
    "8": ["54868"],
    "9": ["53402"],
    "10": ["54401"],
    "11": ["53081"],
    "12": ["53051"],
    "13": ["54501"],
    "14": ["53511"],
    "15": ["53913"],
    "16": ["54115"],
  },
  MI: {
    "1": ["48101"],
    "2": ["48007"],
    "3": ["48001"],
    "4": ["48103"],
    "5": ["48003"],
    "6": ["48401"],
    "7": ["48805"],
    "8": ["48601"],
    "9": ["49013"],
    "10": ["49001"],
    "11": ["49035"],
    "12": ["48885"],
    "13": ["48620"],
    "14": ["49614"],
    "15": ["48627"],
    "16": ["49801"],
  },
  IL: {
    "1": ["60621"],
    "2": ["60042"],
    "3": ["60134"],
    "4": ["60432"],
    "5": ["61008"],
    "6": ["62321"],
    "7": ["61483"],
    "8": ["61764"],
    "9": ["60957"],
    "10": ["62301"],
    "11": ["62246"],
    "12": ["62298"],
    "13": ["62858"],
  },
  MO: {
    "1": ["64506"],
    "2": ["63401"],
    "3": ["64118"],
    "4": ["65301"],
    "5": ["65203"],
    "6": ["63376"],
    "7": ["64804"],
    "8": ["65807"],
    "9": ["65401"],
    "10": ["63701"],
  },
  LA: {
    "1": ["70072"],
    "2": ["70301"],
    "3": ["70560"],
    "4": ["70605"],
    "5": ["70726"],
    "6": ["71360"],
    "7": ["71203"],
    "8": ["71111"],
  },
  KY: {
    "1": ["42003"],
    "2": ["42240"],
    "3": ["42701"],
    "4": ["42101"],
    "5": ["40475"],
    "6": ["41042"],
    "7": ["41102"],
    "8": ["40701"],
  },
  NC: {
    "1": ["28806"],
    "2": ["28655"],
    "3": ["28607"],
    "4": ["28269"],
    "5": ["28092"],
    "6": ["27284"],
    "7": ["27406"],
    "8": ["27247"],
    "9": ["28314"],
    "10": ["27565"],
    "11": ["27713"],
    "12": ["27909"],
    "13": ["27610"],
    "14": ["27858"],
    "15": ["28540"],
    "16": ["28562"],
  },
  OK: {
    "1": ["74955"],
    "2": ["73505"],
    "3": ["73099"],
    "4": ["74012"],
    "5": ["73401"],
  },
  KS: {
    "1": ["66062"],
    "2": ["66614"],
    "3": ["67401"],
    "4": ["67601"],
    "5": ["67846"],
    "6": ["67212"],
    "7": ["66762"],
  },
  AL: {
    "1": ["36265"],
    "2": ["36830"],
    "3": ["35242"],
    "4": ["36867"],
    "5": ["35601"],
    "6": ["36301"],
    "7": ["35630"],
    "8": ["35901"],
    "9": ["35758"],
    "10": ["36695"],
    "11": ["36117"],
    "12": ["35401"],
    "13": ["36330"],
  },
  AK: {
    "1": ["99504"],
    "2": ["99654"],
    "3": ["99801"],
  },
  AS: {
    "1": ["96799"],
  },
  AZ: {
    "1": ["86001"],
    "2": ["86314"],
    "3": ["85364"],
    "4": ["85225"],
    "5": ["85541"],
    "6": ["85705"],
    "7": ["85635"],
  },
  AR: {
    "1": ["72034"],
    "2": ["72401"],
    "3": ["72764"],
    "4": ["71913"],
    "5": ["71603"],
    "6": ["71854"],
    "7": ["72956"],
  },
  DE: {
    "1": ["19720"],
  },
  DC: {
    "1": ["20011"],
  },
  GU: {
    "1": ["96921"],
  },
  HI: {
    "1": ["96797"],
  },
  ID: {
    "1": ["83876"],
    "2": ["83501"],
    "3": ["83704"],
    "4": ["83460"],
    "5": ["83337"],
    "6": ["83215"],
  },
  IA: {
    "1": ["50158"],
    "2": ["50317"],
    "3": ["51106"],
    "4": ["51503"],
    "5": ["52761"],
    "6": ["52001"],
    "7": ["50401"],
  },
  ME: {
    "1": ["04103"],
    "2": ["04901"],
    "3": ["04401"],
    "4": ["04605"],
  },
  MN: {
    "1": ["55901"],
    "2": ["55811"],
    "3": ["56001"],
    "4": ["56073"],
    "5": ["56201"],
    "6": ["56560"],
    "7": ["56601"],
    "8": ["55106"],
    "9": ["56701"],
  },
  MS: {
    "1": ["38654"],
    "2": ["38801"],
    "3": ["39110"],
    "4": ["39401"],
    "5": ["39503"],
    "6": ["39759"],
  },
  MT: {
    "1": ["59102"],
    "2": ["59701"],
    "3": ["59901"],
    "4": ["59840"],
  },
  NE: {
    "1": ["68104"],
    "2": ["68516"],
    "3": ["68701"],
    "4": ["69101"],
  },
  NM: {
    "1": ["87121"],
    "2": ["87401"],
    "3": ["88001"],
    "4": ["87507"],
    "5": ["88101"],
  },
  ND: {
    "1": ["58501"],
    "2": ["58103"],
    "3": ["58201"],
    "4": ["58701"],
  },
  PA: {
    "1": ["16335"],
    "2": ["15857"],
    "3": ["17701"],
    "4": ["15601"],
    "5": ["16601"],
    "6": ["18102"],
    "7": ["17603"],
    "8": ["19120"],
    "9": ["17042"],
  },
  PR: {
    "1": ["00740"],
  },
  RI: {
    "1": ["02860"],
  },
  SC: {
    "1": ["29620"],
    "2": ["29803"],
    "3": ["29810"],
    "4": ["29621"],
    "5": ["29003"],
    "6": ["29812"],
    "7": ["29910"],
    "8": ["29445"],
    "9": ["29135"],
    "10": ["29464"],
    "11": ["29340"],
    "12": ["29706"],
    "13": ["29520"],
    "14": ["29102"],
    "15": ["29488"],
    "16": ["29550"],
    "17": ["29536"],
    "18": ["29483"],
    "19": ["29824"],
    "20": ["29180"],
    "21": ["29501"],
    "22": ["29440"],
    "23": ["29681"],
    "24": ["29646"],
    "25": ["29918"],
    "26": ["29526"],
    "27": ["29936"],
    "28": ["29020"],
    "29": ["29720"],
    "30": ["29360"],
    "31": ["29010"],
    "32": ["29072"],
    "33": ["29835"],
    "34": ["29571"],
    "35": ["29512"],
    "36": ["29108"],
    "37": ["29678"],
    "38": ["29115"],
    "39": ["29640"],
    "40": ["29223"],
    "41": ["29138"],
    "42": ["29301"],
    "43": ["29150"],
    "44": ["29379"],
    "45": ["29556"],
    "46": ["29732"],
  },
  SD: {
    "1": ["57701"],
    "2": ["57106"],
    "3": ["57401"],
    "4": ["57078"],
  },
  TN: {
    "1": ["37660"],
    "2": ["37918"],
    "3": ["37421"],
    "4": ["37013"],
    "5": ["38305"],
    "6": ["38017"],
    "7": ["38501"],
    "8": ["38401"],
  },
  UT: {
    "1": ["84321"],
    "2": ["84404"],
    "3": ["84118"],
    "4": ["84604"],
    "5": ["84770"],
    "6": ["84078"],
  },
  VT: {
    "1": ["05401"],
  },
  VI: {
    "1": ["00820"],
  },
  WV: {
    "1": ["25901"],
    "2": ["25177"],
    "3": ["25508"],
    "4": ["25801"],
    "5": ["25701"],
    "6": ["25414"],
    "7": ["26726"],
    "8": ["26554"],
    "9": ["26301"],
    "10": ["26101"],
    "11": ["26003"],
  },
  WY: {
    "1": ["82601"],
    "2": ["82001"],
    "3": ["82901"],
  },
};

export const TOOLTIP_MESSAGES = {
  organization_type: "The organization of your business entity - corporation, LLC, etc.",
  date_established_at: "Estimate to the nearest month if you can't remember exactly.",
  sic_code:
    "You can lookup your SIC code <a href ='http://www.osha.gov/pls/imis/sicsearch.html' target='_blank'>here.</a> Most internet or software companies are code 7372.",
  fein: "This is located on your latest tax return or on your FEIN receipt from the IRS.",
  domestic_partner_coverage: "Most companies choose <strong>yes</strong>. Answer yes to extend coverage to domestic partners, not just spouses.",
  probationary_period:
    "Most companies choose <strong>'1st of month after hire date'.</strong> Choose a longer period if you don't want coverage to start immediately for new employees - for example, for a trial period hire.",
  months_personal_leave_of_absence:
    "Most companies choose the maximum - <strong>3 months</strong>. This is how long an employee can go on <strong>personal leave</strong> and keep their health insurance.",
  months_medical_leave_of_absence:
    "Most companies choose the maximum - <strong>6 months</strong>. This is how long an employee can go on <strong>approved medical leave</strong> and keep their health insurance.",
  cal_cobra_eligibility: "If you had 2-19 employees for more than half of last year, select yes.",
  cobra_eligibility: "If you had 20 or more employees for at least half of last year, select yes.",
  fmla_eligibility: "If you have 50 or more employees, select yes.",
  group_coverage_replaced_carrier: "Providing this information could reduce the 'waiting period' for pre-exiting conditions from 6 months.",
  hired_at: "Estimate to the nearest month if you can't remember exactly.",
  carve_out: "If you are planning to offer another medical insurance policy alongside this one, mark yes.",
  num_owners: "An owner is somebody that owns equity in your company.",
  number_employees_last_year: "Include both Full and Part Time.",
};

export const EMPLOYEE_FILLER_FIELDS = {
  last_name: "EELast",
  first_name: "EEFirst",
  full_name: "EEFirst A EELast",
  middle_initial: "A",
  home_address: "123 Test Street",
  apt_number: "1",
  city: "Test City",
  state: "CA",
  county: "SAN FRANCISCO",
  zip_code: "94158",
  num_dependents: "4",
  email: "test@simplyinsured.com",
  home_phone: "123121234",
  work_phone: "555555555",
  job_title: "Job Title",
  home_phone_number: "1231231234",
  work_phone_number: "5555555555",
  social_security_number: "868298588",
  marital_status: "single | married | domestic_partner",
  gender: "male | female",
  employee_type: "Full Time | Part Time | 1099 | Other",
  date_of_birth: "04/11/1987",
  date_of_hire: "09/01/2014",
  primary_language: "default: English",
  weight: "150",
  seechange_health_id: "",
  height: "5ft 11in",
  medical_group_number: "abc123",
  dental_group_number: "def456",
  vision_group_number: "ghi789",
  employers_name: "Test Corporation",
  employers_street_address: "123 Employer Street",
  employers_city: "SAN FRANCISCO",
  employers_state: "CA",
  employers_zip_code: "94103",
  employers_contact_name: "Contact Name",
  employers_contact_phone: "345343456",
  employers_contact_fax: "444444444",
  employers_contact_email: "contacttest@simplyinsured.com",
  effective_at: "09/01/2014",
  has_prior_cov: "yes | no",
  first_day_residency: "05/28/2013",
  prior_app_name: "",
  prior_id_num: "",
  prior_policy_num: "",
  prior_cov_name: "",
  prior_start_date: "",
  prior_end_date: "",
  prior_cov_doc_attached: "yes | no",
  reason_for_enrollment: "new_hire | new_enrollment",
  plan_chosen: "Blue Choice Bronze PPO 006-B634CHC-HSA",
  dental_plan_chosen: "PPO Dental",
  vision_plan_chosen: "ACCESS CHOICE PLAN VIS 7 - CONTRIB.",
  num_hours_worked: "40 | 29",
  children_enrolling: "yes | no",
  end_cov_reason: "New coverage",
  is_primary: "default: yes",
  other_cov_same_time: "default: no",
  used_tobacco: "default: no",
  anthem_code: "",
  is_enrolling: "yes | no",
  choose_plan: "Classic 3500",
  is_disabled: "default: no",
  num_children: "3",
  num_children_enrolling: "3",
  num_dependents_total: "4",
  prev_enrolled_kaiser: "no",
  kaiser_prior_id_num: "",
  kaiser_prior_app_name: "",
  dep_has_dif_address: "no",
  family_coverage_type: "ee_only | ee_spouse | ee_children | ee_family",
  prior_cov_type: "group",
  any_child_declining: "yes | no",
  dep1_ssn: "123121234",
  dep1_last_name: "Test1",
  dep1_first_name: "Spouse",
  dep1_full_name: "Spouse Test1",
  dep1_middle_initial: "X",
  dep1_street_address: "123 Test Street",
  dep1_address: "710 Cayman Ln, Foster City, CA, 94404",
  dep1_city: "Foster City",
  dep1_state: "CA",
  dep1_zip_code: "94404",
  dep1_dob: "01/01/2014",
  dep1_height: "5ft 9in",
  dep1_weight: "150",
  dep1_type: "child | spouse",
  dep1_gender: "male | female",
  dep1_has_other_cov: "yes",
  dep1_dif_address: "yes",
  dep1_prior_gender: "",
  dep1_prior_type: "",
  dep1_prior_app_name: "",
  dep1_prior_id_num: "",
  dep1_prior_cov_name: "",
  dep1_prior_start_date: "",
  dep1_prior_end_date: "",
  dep1_end_cov_reason: "New coverage",
  dep1_is_primary: "yes",
  dep1_is_enrolling: "yes | no",
  dep1_refusal_attached: "yes",
  dep1_is_disabled: "default: no",
};

export const EMPLOYER_FILLER_FIELDS = {
  age_29_dependents: "yes | no",
  has_previous_dental_coverage: "yes | no",
  has_previous_dental_orthodontic_coverage: "yes | no",
  previous_dental_coverage_carrier: "text",
  previous_dental_coverage_policy_number: "text (number)",
  previous_dental_coverage_termination_date_at: "text (date)",
  employees_injured_illness_number: "text",
  probationary_period_in_months: "radio: 1 month | 2 months | 3 months | 4 months | 5 months | 6 months",
  eligible_employees_in_waiting_period: "default: 0",
  employees_terminated_in_last_90_days: "default: 0",
  other_health_plan_number_of_employees: "default: 0",
  other_health_plan_open_enrollment_end_date: "to be updated",
  other_health_plan_open_enrollment_start_date: "to be updated",
  other_health_plan_plans_offered: "to be updated",
  employees_cobra_total: "default: ",
  employees_cal_cobra_total: "default: ",
  employees_cal_cobra_enrolling: "default: ",
  employees_cobra_enrolling: "default: ",
  employees_on_workers_compensation: "to be updated",
  subject_to_medicare_laws: "default: no",
  employees_full_time_total: "text (number)",
  employees_part_time_total: "text (number)",
  employees_ineligible_total: "text (number)",
  employees_grand_total: "text (number)",
  employees_1099_total: "default: 0",
  employees_full_time_enrolling: "employees_full_time_enrolling",
  employees_part_time_enrolling: "employees_part_time_enrolling",
  employees_ineligible_enrolling: "employees_ineligible_enrolling",
  employees_total_enrolling: "employees_total_enrolling",
  out_of_state_employees_number: "out_of_state_employees_number",
  termination_of_coverage_date: "text (date)",
  fill_date_day: 24,
  fill_date_month: 9,
  fill_date_month_name: "September",
  fill_date_year: 2014,
  broker_city: "default: San Francisco",
  broker_address: "default: 1018A Minna Street",
  broker_state: "default: CA",
  broker_zip_code: "default: 94103",
  broker_email_address: "default: accounts@simplyinsured.com",
  broker_phone_number: "default: 888-584-7457",
  national_producer_number: "",
  preferred_contact_method: "default: email",
  billing_country: "default: USA",
  administration_kit_mailed_to: "default: broker",
  attest_small_group: "default: yes",
  billing_contact_allowed_to_make_contract_changes: "default: yes",
  broker_appointed_by_carrier: "default: yes",
  broker_can_make_contract_changes: "default: Yes",
  classes_not_insured: "default: None",
  covering_full_time: "default: yes",
  commission_payable_to: "default: broker",
  company_is_subsidiary: "default: no",
  contracts_by_mail: "default: no",
  covered_by_workers_compensation: "default: yes",
  covered_california_certified_insurance_agent: "default: yes",
  employees_currently_eligible_for_cobra: "default: no",
  enroll_in_pop_plan: "default: No",
  enrollment_forms_for_cobra_attached: "default: no",
  erisa_applies: "default: yes",
  file_taxes_on_consolidated_basis: "default: no",
  has_subsidiary: "default: no",
  chiropractic_rider: "default: no",
  infertility_rider: "default: no",
  multiple_tax_id_numbers: "default: no",
  name_for_reporting_purposes: "default: company_name",
  waive_probationary_period_for_current_employees: "default: yes",
  same_carrier_in_past: "default: no",
  hours_to_be_eligible: "default: 40 - update?",
  other_health_plan_offered: "default: no",
  recieve_electronic_documents: "default: yes",
  recieved_sbc: "default: yes",
  split_commission: "default: no",
  has_workers_comp_coverage: "default: yes",
  has_workers_compensation: "default: Yes",
  wc_exempt_reason: "default: ",
  de9c_filed: "default: yes",
  part_time_hours: "default: 20",
  see_change_plan_option: "default: two_metal",
  dental_coverage: "default: no",
  orthodontic_coverage: "default: no",
  life_coverage: "default: no",
  contribution_base_premium_kaiser: "default: average_premium",
  contact_title: "Chief Thing Doer",
  contact_email_address: "contact@fakeemail.com",
  contact_email: "contact@fakeemail.com",
  contact_name: "Contact Name",
  contact_phone_number: "5555555555",
  contact_fax_number: "5555555555",
  authorized_representative_email_address: "contact@fakeemail.com",
  authorized_representative_name: "Contact Name",
  authorized_representative_phone_number: "5555555555",
  bank_account_number: "123123123123",
  bank_name: "Bank of Things",
  bank_routing_number: "1231232312",
  company_name: "test company",
  company_dba: "test dba",
  dba: "test dba",
  business_description: "Stuff, Doing Things",
  fein: "123123123",
  sic_code: "6311",
  organization_type_other: "",
  group_number: "",
  existing_group_number: "",
  employees_last_year: 5,
  previous_insurance_group_number: "",
  group_coverage_replaced_carrier: "",
  group_coverage_replaced_start_date_at: "",
  group_coverage_replaced_carrier_phone_number: "",
  group_coverage_replaced_group_id: "",
  group_coverage_replaced_number_of_employees: "text (number)",
  group_coverage_replaced_policy_number: "text (number)",
  workers_compensation_carrier: "text",
  out_of_state_employees_total: "",
  out_of_state_employees_state: "",
  business_address_same_as_mailing_address: "yes | no",
  same_as_mailing_address: "yes | no",
  cal_cobra_eligibility: "yes | no",
  cobra_eligibility: "yes | no",
  carve_out: "yes | no",
  covering_part_time: "yes | no",
  domestic_partner_coverage: "yes | no",
  employees_injured_illness: "yes | no",
  group_coverage_90_days: "yes | no",
  group_coverage_replaced: "yes | no",
  months_medical_leave_of_absence: "3 months | 6 months | None | 1 month | 4 months | 5 months | 2 months",
  months_personal_leave_of_absence: "2 months | None | 3 months | 1 month",
  organization_type: "Partnership | Corporation | Other | LLC | Sole Proprietorship",
  payment_type: "check_ach | ach_only | check_only",
  owner1_first_name: "text",
  owner1_last_name: "text",
  owner1_middle_initial: "text",
  owner2_first_name: "text",
  owner2_last_name: "text",
  owner2_middle_initial: "text",
  owner3_first_name: "text",
  owner3_last_name: "text",
  owner3_middle_initial: "text",
  owner4_first_name: "text",
  owner4_last_name: "text",
  owner4_middle_initial: "text",
  owner1_percent: "text (e.g. 80%)",
  owner2_percent: "text",
  owner3_percent: "text",
  owner4_percent: "text",
  owner1_eligibility: "yes | no",
  owner2_eligibility: "yes | no",
  owner3_eligibility: "yes | no",
  owner4_eligibility: "yes | no",
  organization_type_covered_ca: "text",
  previously_insured_by_insurer: "yes | no",
  probationary_period: "1st of month after hire date | 1 month | 3 months | 6 months | 2 months | Immediately",
  date_established_month: 9,
  date_established_year: 2014,
  business_length: "0 months",
  termination_of_coverage: "",
  coverage_start_date_day: 1,
  coverage_start_date_month: 10,
  coverage_start_date_year: 2014,
  group_coverage_replaced_termination_date_at: "",
  group_coverage_replaced_termination_date_at_day: "",
  group_coverage_replaced_termination_date_at_month: "",
  group_coverage_replaced_termination_date_at_year: "",
  workers_compensation_renewal_date: "text (date)",
  plan_name: "Blue Choice Bronze PPO 006-B634CHC-HSA",
  dental_plan_name: "PPO Dental",
  vision_plan_name: "ACCESS CHOICE PLAN VIS 7 - CONTRIB.",
  had_20_employees_last_year: "yes | no",
  offering_dependent_coverage: "yes | no",
  plan_chosen: "Blue Choice Bronze PPO 006-B634CHC-HSA",
  out_of_state_employees: "yes | no",
  billing_county: "",
  mailing_county: "SAN FRANCISCO",
  fmla_eligibility: "yes | no",
  exchange_metal_tier: "bronze",
  new_enrollment: "On",
  suite_metal: "",
  contact_first_name: "Contact",
  contact_last_name: "Name",
  contact_middle_initial: "",
  effective_date: "10/01/2014",
  print_officer_name_and_title: "Contact Name, Chief Thing Doer",
  requested_effective: "Wed, 01 Oct 2014",
  requested_effective_day: 1,
  requested_effective_month: 10,
  requested_effective_month_name: "October",
  requested_effective_year: 2014,
};

export const LIST_ENROLLMENTS_CSV_HEADERS = [
  "Effective Date",
  "Record Type  (Employee or Dependent)",
  "Eligible Employee SSN (Employee's SSN)",
  "First Name",
  "Last Name",
  "Birth Date",
  "Hire Date",
  "Gender",
  "Relationship (Employee, Spouse or Child)",
  "Marital Status",
  "Home Address Line 1",
  "Home Address Line 2",
  "City",
  "State / Territory",
  "Zip",
  "Home Phone",
  "Work Phone",
  "Email Address",
  "Dependent SSN (If employee, blank; if Dependent, SSN)",
  "Salary",
  "Salary Frequency",
  "Coverage Termination Date",
  "Current Medical Insurance Status",
  "Medical Plan Carrier",
  "Medical Plan",
  "Medical Plan ID (SimplyInsured's ID #)",
  "Current Dental Insurance Status",
  "Dental Plan Carrier",
  "Dental Plan",
  "Dental Plan ID (SimplyInsured's ID #)",
  "Current Vision Insurance Status",
  "Vision Plan Carrier",
  "Vision Plan",
  "Vision Plan ID (SimplyInsured's ID #)",
];

export const ANTHEM_CSV_HEADERS = [
  "CASE",
  "QUALIFYING EVENT REASON",
  "QUALIFYING EVENT DATE",
  "EMPLOYEES SOCIAL",
  "HCID",
  "LAST NAME",
  "FIRST NAME",
  "MIDDLE INITIAL",
  "GENDER",
  "RELATIONSHIP CODE",
  "MARITAL STATUS",
  "DOB",
  "EMAIL",
  "MEMBER SSN",
  "GROUP TYPE",
  "PHONE NUMBER",
  "ADDRESS",
  "CITY",
  "STATE",
  "ZIP CODE",
  "SECOND ADDRESS FIELD",
  "LANGUAGE",
  "JOB TITLE",
  "COB",
  "DOH",
  "SUBGROUP NUMBER",
  "DEPARTMENT NUMBER",
  "EMPLOYEE NUMBER",
  "EFFECTIVE DATE FOR COVERAGE",
  "PROBATION TYPE",
  "FSA PRODUCT",
  "FSA PRODUCT NAME",
  "MEDICAL PRODUCT",
  "MEDICAL PRODUCT NAME",
  "PRIMARY CARE PHYSICIAN",
  "CURRENT PCP",
  "DENTAL PRODUCT",
  "DENTAL PRODUCT NAME",
  "DENTAL OFFICE",
  "VISION PRODUCT",
  "VISION PRODUCT NAME",
  "STD",
  "LTD",
  "VOLUNTARY STD",
  "VOLUNTARY LTD",
  "BUY-UP LTD",
  "BUY-UP STD",
  "SALARY",
  "GRANDFATHERED DISABILITY",
  "BASIC LIFE",
  "BASIC MULTIPLIER",
  "BASIC SUB VOLUME",
  "BASIC SPOUSE VOLUME",
  "BASIC CHILD(REN) VOLUME",
  "OPTIONAL LIFE",
  "OPTIONAL MULTIPLIER",
  "OPTIONAL SUB VOLUME",
  "OPTIONAL SPOUSE VOLUME",
  "OPTIONAL CHILD(REN) VOLUME",
  "VOLUNTARY LIFE",
  "VOLUNTARY MULTIPLIER",
  "VOLUNTARY SUB VOLUME",
  "VOLUNTARY SPOUSE VOLUME",
  "VOLUNTARY CHILD(REN) VOLUME",
  "GRANDFATHERED LIFE",
  "BASIC AD&D",
  "AD&D BASIC MULTIPLIER",
  "AD&D BASIC SUB VOLUME",
  "AD&D BASIC SPOUSE VOLUME",
  "AD&D BASIC CHILD(REN) VOLUME",
  "OPTIONAL AD&D",
  "AD&D OPTIONAL MULTIPLIER",
  "AD&D OPTIONAL SUB VOLUME",
  "AD&D OPTIONAL SPOUSE VOLUME",
  "AD&D OPTIONAL CHILD(REN) VOLUME",
  "VOLUNTARY AD&D",
  "AD&D VOLUNTARY MULTIPLIER",
  "AD&D VOLUNTARY SUB VOLUME",
  "AD&D VOLUNTARY SPOUSE VOLUME",
  "AD&D VOLUNTARY CHILD(REN) VOLUME",
  "GRANDFATHERED ADD",
  "COBRA START DATE",
  "COBRA QUALIFYING EVENT",
  "MEDICARE HIB/HIC ID",
  "MEDICARE PART A EFF DATE",
  "MEDICARE PART B EFF DATE",
];

export const SIMPLY_INSURED_IPS = ["162.217.75.133", "104.54.246.82"];

export const SLACK_WEBHOOK_URLS = {
  simplyinsured: "https://hooks.slack.com/services/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",
  zero_churn_team: "https://hooks.slack.com/services/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",
  development_notificat: "https://hooks.slack.com/services/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",
  mailgun_notifications: "https://hooks.slack.com/services/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",
  intuit_oauth_completions: "https://hooks.slack.com/services/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",
};

export const TEN_250_ALL_IDS = [71314, 495222, 495224, 495225, 495223];

export const TEN_250_COMPANY_ID = 71314;

export const TEN_250_CALIFORNIA = 495222;

export const TEN_250_UT_NEAR_SALT_LAKE = 495224;

export const TEN_250_UT_ID_NV_EXCEPT_SALT_LAKE = 495225;

export const TEN_250_ALL_OTHER_STATES = 495223;

export const POLICY_STATUS = {
  ENROLLED: "enrolled",
  TERMINATED: "terminated",
  DECLINED: "declined",
  SELECTED: "selected",
  SUBMITTED: "submitted",
  CANCELLED: "cancelled",
  CLOSED: "closed",
  UNKNOWN: "unknown",
};

export const POLICY_STATUS_DESCRIPTIONS = {
  cancelled: "This policy has been marked cancelled.",
  terminated: "This policy has been marked terminated, but is not cancelled yet.",
  declined: "The employee declined to enroll in this policy.",
  enrolled: "This policy has been marked enrolled.",
  selected: "This policy has not been marked enrolled but a plan has been selected.",
  submitted: "This policy has been marked submitted and has not yet been enrolled.",
  closed: "This policy has been marked closed.",
  unknown: "No plan has been selected for this policy yet.",
};

export const SSN_PLACEHOLDER = "867530999";

export const EMPLOYEE_PROFILE_MIN_AGE = 0;

export const EMPLOYEE_PROFILE_MAX_AGE = 150;

export const ACA_CHILD_CAP_LIMIT = 3;

export const ACA_CHILD_CAP_AGE = 21;

export const PRESUMED_ADULT_AGE = 30;

export const PRESUMED_CHILD_AGE = 14;
